'kiwi public';

var methods = {
  props: {},
  status: function status(props) {
    // let props = this.props;
    if (!props.user || !props.buffer) {
      return '';
    }
    return props.user.typingStatus(props.buffer.name).status;
  }
};
export default {
  props: {
    user: Object,
    buffer: Object
  },
  m: methods
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["TypingStatusIndicator"]
window._kiwi_exports.components.TypingStatusIndicator = (typeof exports !== 'undefined' ? (exports.default || exports) : (typeof module !== 'undefined' && module.exports ? (module.exports.default || module.exports) : {}));
